module.exports = __webpack_public_path__ + "img/appBrand--ax-full.086fb2a8.svg";